module.exports = __webpack_public_path__ + "af1a937a043d82202ce1e151f1babd5a.woff";